import React from 'react'
import styled from 'styled-components'
import SkeletonWrapper from 'components/Skeleton/SkeletonWrapper'
import Skeleton from 'react-loading-skeleton'

const ProducListSkeleton = () => {
  const categories = [1, 2, 3, 4, 5]
  const products = [1, 2, 3, 4]
  const productRow = [1, 2]

  return (
    <Wrapper>
      <Header>
        <BrandDetail>
          <Skeleton width={30} height={30} circle />
          <div>
            <Skeleton width={110} height={25} borderRadius={5} style={{ marginBottom: 5 }} />
            <Skeleton width={80} height={20} borderRadius={5} />
          </div>
        </BrandDetail>
        <Tools>
          <Skeleton width={20} height={20} borderRadius={5} />
          <Skeleton width={57} height={20} borderRadius={5} />
        </Tools>
      </Header>
      <Category>
        {categories.map((key) => (
          <Skeleton key={key} width={`calc(((100vw - 15px - 8px) / 4) - 8px)`} height={120} borderRadius={8} />
        ))}
      </Category>
      <ProducList>
        <div>
          <Skeleton width={110} height={25} borderRadius={5} style={{ marginBottom: 5 }} />
          <Skeleton width={80} height={20} borderRadius={5} />
        </div>
        {products.map((product) => (
          <ProductRow key={product}>
            {productRow.map((row) => (
              <ProductItem key={row}>
                <ProductThumbnail height={`calc(52vw - 38px)`} borderRadius={5} />
                <ProductDetail>
                  <Skeleton width={100} height={25} borderRadius={5} />
                  <Skeleton width={40} height={40} borderRadius={20} />
                </ProductDetail>
              </ProductItem>
            ))}
          </ProductRow>
        ))}
      </ProducList>
    </Wrapper>
  )
}

export default ProducListSkeleton

const Wrapper = styled(SkeletonWrapper)`
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
`

const BrandDetail = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`

const Tools = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
`

const Category = styled.div`
  display: flex;
  align-items: inherit;
  justify-content: space-between;
  column-gap: 8px;
  padding: 15px 8px 15px 15px;
  overflow: auto;
  white-space: nowrap;
`

const ProducList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
`

const ProductRow = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 15px;
`

const ProductItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 48%;
`
const ProductDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ProductThumbnail = styled(Skeleton)`
  width: 100%;
`
